import { get } from "@/infra/rest";
import { ListOfOrganizationByEmail, SsoAuthenticateResponse } from "../types";
import appConfig from "@/shared/config/app";
import { getCookie, setCookie, deleteCookie } from "@/shared/utils/cookie-helper";

// Store authentication method in cookie
export const storeAuthMethod = (method: 'sso' | 'email'): void => {
  // Set cookie with 30 days expiry
  setCookie('sso_auth_method', method, 30);
};

// Clear authentication method on logout
export const clearAuthMethod = (): void => {
  deleteCookie('sso_auth_method');
};

// Function to check if user logged in via SSO
export const isUserLoggedInViaSSO = (): boolean => {
  return getCookie('sso_auth_method') === 'sso';
};

// Get the auth method from cookie
export const getAuthMethod = (): string => {
  return getCookie('sso_auth_method') || 'email'; // Default to email if not found
};

export const startSsoConnection = async (connectionId: string) => {
  try {
    const redirectUrl = `${window.location.origin}/auth`;
    const publicToken = appConfig.stytchKey;
    const stytchBaseUrl = appConfig.stytchBaseUrl;
    if (stytchBaseUrl && redirectUrl && connectionId) {
      const ssoUrl = `${stytchBaseUrl}/v1/public/sso/start?connection_id=${connectionId}&public_token=${publicToken}
      &login_redirect_url=${redirectUrl}&signup_redirect_url=${redirectUrl}`;
      window.location.href = ssoUrl;
    }
  } catch (error) {
    throw new Error((error as Error).message);
  }
};


export const authenticateSso = async (token: string) => {
  try {
    const data = await get<SsoAuthenticateResponse>({
      url: `/v0/auth/sso-authenticate/${token}`,
      isAuthRequired: false,
    });

    return data;
  } catch (err) {
    throw new Error('Failed to authenticate');
  }
}

export const getListOfOrganizationBasedOnEmail: (
  q: string,
) => Promise<string[]> = async (q) => {
  try {
    const organizations = await get<ListOfOrganizationByEmail>({
      url: `/v0/auth/sso/orgs?user_email=${q}`,
      isAuthRequired: false,
    });

    return organizations.payload;
  } catch (err) {
    console.error(err);
    throw new Error('Failed to get organization');
  }
};
